import { ValueOf } from '../../utilities';
import { LanguageCode } from '../core';

/**
 * @see DesignLanguage.ttsFallBackVoice.
 *
 * @note This would ideally be an enum, but the [reverse mappings](https://www.typescriptlang.org/docs/handbook/enums.html#reverse-mappings)
 * mess with `Object.values`.
 */
export const TextToSpeechVoice = {
  achernarEnglishUs: `Achernar-${LanguageCode.englishUs}`,
  achirdEnglishUs: `Achird-${LanguageCode.englishUs}`,
  alloyEnglishUs: `Alloy-${LanguageCode.englishUs}`,
  aoedeEnglishUs: `Aoede-${LanguageCode.englishUs}`,
  aoedeSpanishUs: `Aoede-${LanguageCode.spanishUs}`,
  ashleyEnglishUs: `Ashley-${LanguageCode.englishUs}`,
  bridgetEnglishUk: `Bridget-${LanguageCode.englishUk}`,
  callirrhoeDutchNl: `Callirrhoe-${LanguageCode.dutchNl}`,
  callirrhoeEnglishUs: `Callirrhoe-${LanguageCode.englishUs}`,
  callirrhoeSpanishUs: `Callirrhoe-${LanguageCode.spanishUs}`,
  cathyEnglishUs: `Cathy-${LanguageCode.englishUs}`,
  charonArabicXa: `Charon-${LanguageCode.arabicXa}`,
  charonChineseMandarinCn: `Charon-${LanguageCode.chineseMandarinCn}`,
  charonEnglishUs: `Charon-${LanguageCode.englishUs}`,
  charonFrenchCa: `Charon-${LanguageCode.frenchCa}`,
  charonFrenchFr: `Charon-${LanguageCode.frenchFr}`,
  charonGermanDe: `Charon-${LanguageCode.germanDe}`,
  charonSpanishUs: `Charon-${LanguageCode.spanishUs}`,
  charonTurkishTr: `Charon-${LanguageCode.turkishTr}`,
  chenChineseMandarinCn: `Chen-${LanguageCode.chineseMandarinCn}`,
  chrisEnglishUs: `Chris-${LanguageCode.englishUs}`,
  claudeFrenchFr: `Claude-${LanguageCode.frenchFr}`,
  corrbetteEnglishUs: `Corrbette-${LanguageCode.englishUs}`,
  danteItalianIt: `Dante-${LanguageCode.italianIt}`,
  dennisEnglishUs: `Dennis-${LanguageCode.englishUs}`,
  despinaSpanishUs: `Despina-${LanguageCode.spanishUs}`,
  diegoSpanishUs: `Diego-${LanguageCode.spanishUs}`,
  dieterGermanDe: `Dieter-${LanguageCode.germanDe}`,
  domingoSpanishUs: `Domingo-${LanguageCode.spanishUs}`,
  duncanEnglishGb: `Duncan-${LanguageCode.englishGb}`,
  echoEnglishUs: `Echo-${LanguageCode.englishUs}`,
  enceladusEnglishGb: `Enceladus-${LanguageCode.englishGb}`,
  enceladusEnglishUs: `Enceladus-${LanguageCode.englishUs}`,
  enricoSpanishEs: `Enrico-${LanguageCode.spanishEs}`,
  erdamTurkishTr: `Erdam-${LanguageCode.turkishTr}`,
  erinomeFrenchCa: `Erinome-${LanguageCode.frenchCa}`,
  erinomeFrenchFr: `Erinome-${LanguageCode.frenchFr}`,
  fableEnglishUs: `Fable-${LanguageCode.englishUs}`,
  fayeEnglishUs: `Faye-${LanguageCode.englishUs}`,
  fayeGermanDe: `Faye-${LanguageCode.germanDe}`,
  fernandaSpanishEs: `Fernanda-${LanguageCode.spanishEs}`,
  florenciaSpanishUs: `Florencia-${LanguageCode.spanishUs}`,
  francescaItalianIt: `Francesca-${LanguageCode.italianIt}`,
  francesFrenchFr: `Frances-${LanguageCode.frenchFr}`,
  franciscoSpanishUs: `Francisco-${LanguageCode.spanishUs}`,
  franEnglishGb: `Fran-${LanguageCode.englishGb}`,
  fridaGermanDe: `Frida-${LanguageCode.germanDe}`,
  gacruxSpanishEs: `Gacrux-${LanguageCode.spanishEs}`,
  gacruxSpanishUs: `Gacrux-${LanguageCode.spanishUs}`,
  iapetusEnglishUs: `Iapetus-${LanguageCode.englishUs}`,
  jamesEnglishUs: `James-${LanguageCode.englishUs}`,
  jeffreyEnglishUs: `Jeffrey-${LanguageCode.englishUs}`,
  jessicaEnglishUs: `Jessica-${LanguageCode.englishUs}`,
  kateEnglishUs: `Kate-${LanguageCode.englishUs}`,
  koreFrenchCa: `Kore-${LanguageCode.frenchCa}`,
  koreFrenchFr: `Kore-${LanguageCode.frenchFr}`,
  koreSpanishEs: `Kore-${LanguageCode.spanishEs}`,
  laomedeiaEnglishGb: `Laomedeia-${LanguageCode.englishGb}`,
  laomedeiaEnglishUs: `Laomedeia-${LanguageCode.englishUs}`,
  ledaArabicXa: `Leda-${LanguageCode.arabicXa}`,
  ledaGermanDe: `Leda-${LanguageCode.germanDe}`,
  ledaItalianIt: `Leda-${LanguageCode.italianIt}`,
  ledaSpanishUs: `Leda-${LanguageCode.spanishUs}`,
  leoFrenchCa: `Leo-${LanguageCode.frenchCa}`,
  macieEnglishUs: `Macie-${LanguageCode.englishUs}`,
  matildaSpanishUs: `Matilda-${LanguageCode.spanishUs}`,
  ninoskaSpanishUs: `Ninoska-${LanguageCode.spanishUs}`,
  novaEnglishUs: `Nova-${LanguageCode.englishUs}`,
  oliviaEnglishUs: `Olivia-${LanguageCode.englishUs}`,
  oliviaSpanishUs: `Olivia-${LanguageCode.spanishUs}`,
  onyxEnglishUs: `Onyx-${LanguageCode.englishUs}`,
  orusFrenchCa: `Orus-${LanguageCode.frenchCa}`,
  orusSpanishEs: `Orus-${LanguageCode.spanishEs}`,
  paulEnglishUs: `Paul-${LanguageCode.englishUs}`,
  philEnglishUs: `Phil-${LanguageCode.englishUs}`,
  quinnEnglishUs: `Quinn-${LanguageCode.englishUs}`,
  sadaltagerSpanishUs: `Sadaltager-${LanguageCode.spanishUs}`,
  shimmerEnglishUs: `Shimmer-${LanguageCode.englishUs}`,
  sulafatGermanDe: `Sulafat-${LanguageCode.germanDe}`,
  vindemiatrixEnglishUs: `Vindemiatrix-${LanguageCode.englishUs}`,
  violetaSpanishUs: `Violeta-${LanguageCode.spanishUs}`,
  zephyrArabicXa: `Zephyr-${LanguageCode.arabicXa}`,
  zephyrFrenchFr: `Zephyr-${LanguageCode.frenchFr}`
} as const;

export const defaultTtsVoice = 'default';

/** @see DesignLanguage.ttsFallBackVoice. */
export type TextToSpeechVoice = ValueOf<typeof TextToSpeechVoice>;

/** Used on prompts to access values off from text & channel (default) or the TTS voice overrides. */
export type TextToSpeechVoiceOrDefault = TextToSpeechVoice | typeof defaultTtsVoice;
